import React from 'react';

export const EditFormBlockContext = React.createContext({
  legacy: true,
});

export const EditFormBlockContextProvider = EditFormBlockContext.Provider;
